<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="lo_pleaseman,lo_department"
      placeholder="输入借款人、部门进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="'/oa/loan/'+item.id"
      >
        <div class="weui-cell__bd">
          <p>{{item.lo_pleaseman}} {{item.lo_class}}</p>
          <p class="list-item-muted">{{item.lo_code}}</p>
        </div>
        <div class="weui-cell__ft">
          <p v-format="'¥#,##0.00'">{{item.lo_borrowamount}}</p>
          <span
            class="list-item-status"
            :class="{'warning':item.lo_status!='已审核'}"
          >{{item.lo_status}}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}笔</label>
      <em class="list-footer__value" v-format="'¥#,##0.00'">{{getTotal('lo_borrowamount')}}</em>
    </div>
    <add-button to="/oa/loan_edit" />
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import AddButton from "@/components/button/Add.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
    AddButton
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/oa/loan/list",
      filters: [
        {
          type: "date",
          name: "lo_date"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部"
            },
            {
              value: 1,
              label: "待审核",
              condition: "lo_statuscode='UNAUDITED'"
            },
            {
              value: 2,
              label: "已审核",
              condition: "lo_statuscode='AUDITED'"
            }
          ]
        }
      ]
    };
  }
};
</script>